import { OfficeReviewsApi } from '../clients';

/**
 * Deletes an office review, by its monolith review id.
 *
 * Nothing to map on the way out — the endpoint returns no body — so this exists
 * for symmetry with `getOfficeReviews`: the thunk talks to `services` and never
 * reaches into `clients`.
 *
 * @param {string} monolithReviewId
 * @returns {Promise<void>}
 */
export const deleteOfficeReview = async (monolithReviewId) =>
  OfficeReviewsApi.deleteOfficeReview(monolithReviewId);
